import { useLocation, useHistory } from "react-router-dom";

export default function useQuery() {
  const location = useLocation();
  const history = useHistory();

  const get = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const set = (key, value, options = { replace: false }) => {
    const params = new URLSearchParams(location.search);

    if (value === null || value === undefined) {
      params.delete(key);
    } else {
      params.set(key, value);
    }

    const method = options.replace ? history.replace : history.push;

    method({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const getAll = () => {
    return Object.fromEntries(new URLSearchParams(location.search));
  };

  const remove = (key, options = { replace: false }) => {
    set(key, null, options);
  };

  return {
    get,
    set,
    getAll,
    remove,
    search: location.search,
  };
}